import { render, staticRenderFns } from "./SlideCurator.vue?vue&type=template&id=09e88078&"
import script from "./SlideCurator.vue?vue&type=script&lang=js&"
export * from "./SlideCurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports